import {
  Badge,
  Button,
  Dialog,
  HStack,
  Input,
  Portal,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { InputGroup } from "../ui/input-group";
import { LiaCcVisa } from "react-icons/lia";
import { LiaCcMastercard } from "react-icons/lia";
import { getCardType } from "../../Utils/newHelper";
import { addNewAddress } from "../../Redux/Action";
import { useDispatch } from "react-redux";

export const CardForm = ({ isCardDialogOpen, setIsCardDialogOpen }) => {
  const [formData, setFormData] = useState({
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
  });
  const dispatch = useDispatch();
  const [cardType, setCardType] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cardNumber") {
      const cleaned = value.replace(/\D/g, "").slice(0, 16);
      const formattedValue = cleaned.replace(/(\d{4})(?=\d)/g, "$1 ");
      setFormData((prev) => ({ ...prev, [name]: formattedValue }));
      const type = getCardType(formattedValue);
      setCardType(type);
    } else if (name === "expiry") {
      const cleaned = value.replace(/\D/g, "").slice(0, 6); // Accept 6 digits
      let formatted = cleaned;

      if (cleaned.length >= 3) {
        formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`; // MM/YYYY
      }
      setFormData((prev) => ({ ...prev, [name]: formatted }));
    } else if (name === "cardHolderName") {
      const cleaned = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: cleaned }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    const newErrors = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "This field is required";
        hasError = true;
      }
    });

    if (!hasError) {
      formData.cardNumber = formData.cardNumber.replace(/\s/g, "");
      setIsCardDialogOpen(false);
      dispatch(
        addNewAddress({
          submit: "card",
          payload: formData,
          callback: (data) => {},
        })
      );
    }
  };

  return (
    <Dialog.Root
      size="xs"
      placement="center"
      motionPreset="scale"
      open={isCardDialogOpen}
      onOpenChange={(e) => setIsCardDialogOpen(e.open)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header textAlign="center">
              <Dialog.Title>Add New Card</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <Stack
                gap="4"
                align="center"
                maxW="sm"
                margin="auto"
                borderRadius="10px"
              >
                <Input
                  name="cardHolderName"
                  placeholder="Card Holder Name"
                  value={formData.cardHolderName}
                  onChange={handleChange}
                />
                <InputGroup
                  width="100%"
                  endElement={
                    cardType === "Mastercard" ? (
                      <LiaCcMastercard />
                    ) : cardType === "Visa" ? (
                      <LiaCcVisa />
                    ) : null
                  }
                >
                  <Input
                    name="cardNumber"
                    placeholder="Card Number"
                    value={formData.cardNumber}
                    onChange={handleChange}
                  />
                </InputGroup>
                <HStack width="100%">
                  <Input
                    name="expiry"
                    placeholder="MM/YYYY"
                    value={formData.expiry}
                    onChange={handleChange}
                  />
                </HStack>
              </Stack>
            </Dialog.Body>
            <Dialog.Footer justifyContent="center">
              <VStack>
                <Text
                  fontSize="xs"
                  color="gray.600"
                  animation="pulse 2s infinite"
                >
                  Only{" "}
                  <Badge colorPalette="green" variant="surface" size="xs">
                    Visa{" "}
                  </Badge>{" "}
                  &{" "}
                  <Badge colorPalette="green" variant="surface" size="xs">
                    Mastercard
                  </Badge>{" "}
                  accepted.
                </Text>
                <Button variant="surface" type="submit" onClick={handleSubmit}>
                  Submit
                </Button>
              </VStack>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
